export const messages = {
  en: {
    batchPayFeeOrder: {
      title: 'Batch Payment',
      feeType: 'Fee Type',
      feeItem: 'Fee Item', 
      feeFlag: 'Fee Flag',
      payerObj: 'Payer Object',
      area: 'Area',
      oweDays: 'Overdue Days',
      receivablePeriod: 'Receivable Period',
      receivable: 'Receivable/Owed',
      paymentCycle: 'Payment Cycle',
      actualAmount: 'Actual Amount',
      remark: 'Remark',
      month: 'months',
      enterActualAmount: 'Enter actual amount',
      enterRemark: 'Enter remark',
      scanPay: 'Scan Payment',
      submitPay: 'Submit Payment'
    },
    payFeeUserAccount: {
      title: 'Account Information',
      accountType: 'Account Type',
      accountName: 'Account Name',
      accountAmount: 'Account Amount',
      operation: 'Operation',
      preSave: 'Pre-save',
      yuan: 'yuan'
    },
    batchPayConfirm: {
      title: 'Payment Confirmation',
      amount: 'Amount:',
      accountAmount: 'Account Amount:',
      paymentMethod: 'Payment Method:',
      selectPaymentMethod: 'Please select payment method',
      scanCodeTip: 'Please scan with scanner',
      confirmPay: 'Confirm Payment',
      payResult: 'Payment Result',
      paySuccess: 'Payment Successful',
      mergePrint: 'Merge Print',
      printReceipt: 'Print Receipt',
      yuan: 'yuan'
    },
    batchFeeCycle: {
      paymentCycle: 'Payment Cycle',
      selectCycleTip: 'Please select payment cycle',
      default: 'Default',
      customCycle: 'Custom Cycle',
      customAmount: 'Custom Amount',
      customEndTime: 'Custom End Time',
      actualCycle: 'Actual Cycle',
      enterActualCycle: 'Enter actual cycle',
      endTime: 'End Time',
      selectEndTime: 'Select end time',
      enterCustomAmount: 'Enter custom amount'
    }
  },
  zh: {
    batchPayFeeOrder: {
      title: '批量缴费',
      feeType: '费用类型',
      feeItem: '费用项目',
      feeFlag: '费用标识',
      payerObj: '收费对象',
      area: '房屋面积',
      oweDays: '欠费时长',
      receivablePeriod: '应收时间段',
      receivable: '应收/欠费',
      paymentCycle: '缴费周期',
      actualAmount: '实收',
      remark: '备注',
      month: '个月',
      enterActualAmount: '请输入实际金额',
      enterRemark: '请输入备注',
      scanPay: '扫码收费',
      submitPay: '提交收费'
    },
    payFeeUserAccount: {
      title: '账户信息',
      accountType: '账户类型',
      accountName: '账户名',
      accountAmount: '账户金额',
      operation: '操作',
      preSave: '预存',
      yuan: '元'
    },
    batchPayConfirm: {
      title: '收费确认',
      amount: '金额：',
      accountAmount: '账户金额：',
      paymentMethod: '支付方式：',
      selectPaymentMethod: '必填，请选择支付方式',
      scanCodeTip: '请用扫码枪扫码',
      confirmPay: '确定收费',
      payResult: '缴费提示',
      paySuccess: '缴费成功',
      mergePrint: '合并打印',
      printReceipt: '打印收据',
      yuan: '元'
    },
    batchFeeCycle: {
      paymentCycle: '缴费周期',
      selectCycleTip: '必填，请选择缴费周期',
      default: '默认',
      customCycle: '自定义周期',
      customAmount: '自定义金额',
      customEndTime: '自定义结束时间',
      actualCycle: '实际周期',
      enterActualCycle: '请输入实际周期',
      endTime: '缴费结束时间',
      selectEndTime: '缴费结束时间',
      enterCustomAmount: '请输入自定义金额'
    }
  }
}